









































































































































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CyuricaWalletKey from "@/components/cyurica-wallet-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const cyuricaWalletStore = inject(CyuricaWalletKey);
    if (!cyuricaWalletStore) {
      throw new Error(`${cyuricaWalletStore} is not provided`);
    }
    const globalStore = context.root.$store;
    const loading = computed(() => globalStore.auth.loading);
    const accessToken = computed(() => globalStore.auth.token);
    const response = computed(() => cyuricaWalletStore.response);

    const consent = async () => {
      cyuricaWalletStore.clearResponse();
      displayuiStore.clearErrorSnackBar;
      await cyuricaWalletStore.consent();
      if (response.value.status >= 400) {
        displayuiStore.showErrorSnackBar("エラーが発生しました。");
      } else {
        context.root.$router.push({ name: "MemberWalletCharge" });
      }
    };

    onMounted(async () => {
      cyuricaWalletStore.setAuthorizationHeader(accessToken.value);
    });

    return {
      loading,
      consent
    };
  },
  components: {}
});
